<template>
  <v-app>
      
      <v-overlay :value="overlay" z-index="999999999" :opacity=1 color="#fff" light>
        <div :style="{ backgroundImage: `url(${logo})` }" class="logo-prime"></div>
        <v-progress-circular
          indeterminate
          color="black"
          size="32"
        ></v-progress-circular>
      </v-overlay>
      <transition name="fade">
        <router-view></router-view>
      </transition>
  </v-app>
</template>

<script>
import logo_dark from "../../assets/logo_dark.png"

export default {
  name: 'DefaultLayout',
  data:() => ({
    overlay: true,
    logo: logo_dark
  }),
  mounted() {
    if(this.$loader){
      this.overlay = true
      let self = this
      setTimeout(() => {
        self.overlay = false
      }, 2300)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.logo-prime {
  width:200px;
  height:90px;
  background-size:contain;
  margin-bottom:100px;
}
.fade-enter-active {
  transition: opacity .5s;
}
.fade-enter /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// src/views/website/layout.vue